import { AppBar, Button } from "@mui/material";
import { useNavigate } from "react-router";
import images from '../../../data/images.json';


export default function MobileHeader(){


    const logo = images.logo.mobile;
    const navigator = useNavigate();

    return (
    <AppBar>
        <Button
            sx={{
                textTransform:'none',
                color:'primary.contrastText'
            }}
            onClick={()=>navigator("")}
        >
            <img 
                src={logo.src}
                alt={logo.alt}
                style={{
                    height:'40px',
                    width:'auto'
                }}
            />
        </Button>
    </AppBar>);
}